<div>
  <canvas *ngIf="isValid; else invalid" #canvas width="1000" height="800"></canvas>
</div>

<ng-template #invalid>
  <p *ngIf="!isFitOld">Age est supérieur à 18 ans</p>
  <p *ngIf="!isValidHeight && !isValidWeight">Données invalides</p>
  <p *ngIf="!isValidHeight && isValidWeight">Taille invalide !</p>
  <p *ngIf="isValidHeight && !isValidWeight">Poids invalide !</p>
</ng-template>